/*
 * @Description: 
 * @Version: 2.0
 * @Autor: sen.yang
 * @Date: 2022-01-05 09:55:19
 * @LastEditors: sen.yang
 * @LastEditTime: 2022-01-13 10:52:15
 */
const recommend = [
    {
      path: '/recommend/detail/:type?/:id',
      name: 'recommendDetail',
      component: () => import('../views/recommend/detail.vue'),
    },
  ]
  export default recommend


// WEBPACK FOOTER //
// ./src/router/recommend.js